import React from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format"

import { getMyOrders, getOrderHistory } from "../../model/car";
import { getBalance} from "../../model/wallet";

import { commonErr } from "../common/errors";
import { TPlatformType } from "../common/common";

import Header from "../common/header";
import Footer from "../common/footer";
import SideBar from "../common/sidebar";

class Dashboard extends React.Component {

	_isMounted = false

	constructor(props) {
		super(props); 

		this.state = { 
			totalUp: 0,
			orders: [],
			commission: 0, 
			f2Commission: 0
		}
		
		this.totalFinishTrips = this.totalFinishTrips.bind(this)
	}

	componentDidMount() {
		this._isMounted = true
		const filter = {
			status: 0,
		}

		getMyOrders(filter, 0, 10).then(resp => {
			if (this._isMounted) {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data.orders) {
					this.setState({
						totalUp: resp.data.data.total,
						err: resp.data.error
					});
						
				} else {
					this.setState({
						err: resp.data.error,
						totalUp: 0,
					});
				}
			}
		});
		
	
		getOrderHistory(filter, 0, 10).then((resp) => {
			if (this._isMounted) {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data.orders) {
					this.setState({
						orders: resp.data.data.orders,
						err: resp.data.error
					});
				} else {
					this.setState({
						err: resp.data.error,
						orders: null
					});
				}
			}
		});
		
		getBalance().then((resp) => {
			if (this._isMounted) {
				if ( resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						commission: resp.data.data.commission,
						f2Commission: resp.data.data.f2Commission,
					})
				} else {
						this.setState({
								err: resp.data.error,
						})
				}
			}
		})
		
	}

	componentWillUnmount() {
    this._isMounted = false;
  }


	totalFinishTrips() {
		const { orders } = this.state; 
		let totalFinish = 0; 

		if(orders.length > 1 ) { 
			orders.map((order, i) => {
				if(order.status === 25) {
					totalFinish += 1
				}
			})
		}
	
		return totalFinish 
	}
	

	render() {
		const { platformType } = this.props.appInit
		const { listF2 } = this.props.listF2
		const { totalUp, orders, commission, f2Commission } = this.state

		const isF1 = listF2.length > 0 


		return <div className="mioto-layout page-wrapper"	>
					<Header />
					<SideBar />
					<div className="content-wrapper">
						<div className="page-content fade-in-up">
							<div className="row mb-4">
								<div className="col-lg-4 col-md-6">
									<div className="card mb-4">
										<div className="card-body flexbox-b">
											<div className="easypie mr-3" data-percent={73} data-bar-color="#18C5A9" data-size={80} data-line-width={8}><span className="easypie-data text-success" style={{fontSize: '28px', position: "relative"}}><i className="ti-shopping-cart" /></span></div>
											<div>
												<h3 className="font-strong text-success">{this.totalFinishTrips()}</h3>
												<div className="text-muted">CHUYẾN ĐÃ HOÀN THÀNH</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6">
									<div className="card mb-4">
										<div className="card-body flexbox-b">
											<div className="easypie mr-3" data-percent={42} data-bar-color="#5c6bc0" data-size={80} data-line-width={8}><span className="easypie-data text-primary" style={{fontSize: '32px', position: "relative"}}><i className="la la-money" /></span></div>
											<div>
												<h3 className="font-strong text-primary">{totalUp > 0 ? totalUp : 0}</h3>
												<div className="text-muted">CHUYẾN SẮP TỚI</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6">
									<div className="card mb-4">
										<div className="card-body flexbox-b">
											<div className="easypie mr-3" data-percent={70} data-bar-color="#ff4081" data-size={80} data-line-width={8}><span className="easypie-data text-pink" style={{fontSize: '32px', position: "relative"}}><i className="la la-users" /></span></div>
											{platformType === TPlatformType.AGENT ? <div>
												<h3 className="font-strong text-pink"><NumberFormat value={commission} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></h3>
												<div className="text-muted">HOA HỒNG</div>
											</div> : <div>
											<h3 className="font-strong text-pink">{orders.total > 0 ? orders.total : 0}</h3>
												<div className="text-muted">TỔNG CHUYẾN</div>
											</div> } 
										</div>
									</div>
								</div>
							</div>
						</div>
						<Footer />
					</div>
			</div>
	}
}


function mapState(state) {
	return {
		appInit: state.appInit,
		listF2: state.listF2
	}
}

Dashboard = connect(mapState)(Dashboard)

export default Dashboard


// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js